export enum CreditStatusEnum {
    ZERO = 'enums.creditStatus.notConsumed',
    ONE = 'enums.creditStatus.partiallyConsumed',
    TWO = 'enums.creditStatus.fullyConsumed'
}
